import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { catturaProvenienza } from "./app/shared/utils/attribution";

/*
 * La provenienza si legge qui, prima di ogni altra cosa (WWP-153).
 *
 * È l'unico punto in cui l'indirizzo è ancora quello con cui la persona è
 * arrivata: un istante dopo entra in funzione il router, e i parametri della
 * campagna spariscono alla prima navigazione. Chi si registra lo fa quasi
 * sempre dopo aver guardato qualcosa, quindi leggerli al momento dell'invio
 * vorrebbe dire non leggerli quasi mai.
 */
catturaProvenienza();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
